import React from 'react';
import { BRAND_REGISTRY } from './HospitalLogoRegistry';

const HospitalLogo = ({ width = 40, height = 40, orgName }) => {
  const brand = BRAND_REGISTRY[orgName] || BRAND_REGISTRY['default'];
  const BrandIcon = brand.Icon;

  return (
    <div 
      style={{ 
        width: width, 
        height: height, 
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* 1. THE OUTER BOUNDARY (Your UI) */}
      <div 
        style={{
          position: 'absolute',
          top: 5, left: 5, right: 5, bottom: 5,
          borderRadius: '50%',
          backgroundColor: '#ffffff',
          opacity: 1,
          zIndex: 1,
          border: '1px solid #eeeeee' // Optional: adds a tiny border if your app background is also white
        }} 
      />

      {/* 2. THE ORIGINAL SVG (The Hospital's Asset) */}
      <div style={{ 
        position: 'relative', 
        zIndex: 2, 
        width: '85%',  // Scales the original SVG to fit inside the circle
        height: '85%', 
        display: 'flex',
        color: brand.color // Forces currentColor if their SVG uses it
      }}>
        <BrandIcon width="100%" height="100%" />
      </div>
    </div>
  );
};

export default HospitalLogo;
